/* eslint-disable */
// @ts-nocheck
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */

import * as Types from '../../../../../../../../api/graphql/generated';

import { LtlStopFragmentFragmentDoc } from './LtlStopFragment.generated';
import { LtlLoadSpecFragmentFragmentDoc } from './LtlLoadSpecFragment.generated';
import { api } from 'api/graphql/baseGraphqlApi';
module.hot?.accept();
export type CreateEmptyQuoteRequestMutationVariables = Types.Exact<{
  mode: Types.Mode;
}>;


export type CreateEmptyQuoteRequestMutation = { __typename?: 'Mutation', createEmptyQuoteRequest?: { __typename?: 'QuoteRequest', id: string, mode: Types.Mode, stops: Array<{ __typename?: 'Stop', id: string, position: number, start?: any | null, end?: any | null, is_na?: boolean | null, is_time_tbd?: boolean | null, note?: string | null, address?: { __typename?: 'Address', id: string, address_1?: string | null, address_2?: string | null, city?: string | null, country_code?: string | null, country_name?: string | null, formatted_long_name: string, formatted_short_name: string, google_place_id?: string | null, google_place_description?: string | null, iana_timezone: string, lat?: string | null, lon?: string | null, name?: string | null, phone_number?: string | null, province_code?: string | null, province_name?: string | null, zip?: string | null, address_contacts: Array<{ __typename?: 'AddressContact', id: string, first_name?: string | null, last_name?: string | null, phone_number?: string | null, email?: string | null }> } | null }>, ltl_load_spec?: { __typename?: 'LtlLoadSpec', id: string, max_temp?: number | null, min_temp?: number | null, total_weight?: number | null, trailer_type?: Types.LtlTrailerType | null, weight_unit?: Types.WeightUnit | null, accessorials: Array<{ __typename?: 'AccessorialsLtlLoadSpecs', id: string, accessorial: { __typename?: 'Accessorial', id: string, name: string, type?: Types.AccessorialType | null } }>, package_groups: Array<{ __typename?: 'PackageGroup', id: string, commodities?: string | null, dim_unit: Types.DimUnit, freight_class?: Types.FreightClass | null, hazardous_goods_details?: string | null, height_per_package?: number | null, is_hazardous?: boolean | null, item_quantity: number, length_per_package?: number | null, packaging_type?: Types.PackagingType | null, packing_count?: number | null, pallet_count?: number | null, weight_per_package?: number | null, width_per_package?: number | null, is_stackable?: boolean | null }> } | null } | null };


export const CreateEmptyQuoteRequestDocument = `
    mutation createEmptyQuoteRequest($mode: Mode!) {
  createEmptyQuoteRequest(mode: $mode) {
    id
    mode
    stops {
      ...LtlStopFragment
    }
    ltl_load_spec {
      ...LtlLoadSpecFragment
    }
  }
}
    ${LtlStopFragmentFragmentDoc}
${LtlLoadSpecFragmentFragmentDoc}`;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    createEmptyQuoteRequest: build.mutation<CreateEmptyQuoteRequestMutation, CreateEmptyQuoteRequestMutationVariables>({
      query: (variables) => ({ document: CreateEmptyQuoteRequestDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateEmptyQuoteRequestMutation } = injectedRtkApi;

